import React from 'react';
import cx from 'classnames';
import { t, props } from 'tcomb-react';

@props({
  children: t.Any,
  className: t.Str
})
export default class Media extends React.Component {

  getClasses() {
    const className = this.props.className;
    const classes = {
      'media': true
    };
    classes[className] = 'true';
    return cx(classes);
  }

  render() {
    return (
      <div className={this.getClasses()}>
        <div className='media-left'>
          <div className='icon' />
        </div>
        <div className='media-right'>
          {this.props.children}
        </div>
      </div>
    );
  }
}




/** WEBPACK FOOTER **
 ** C:/repository/madai/v6/client/lib/web/components/Media.js
 **/